export default "__VITE_ASSET__CrqhDb83__"